module.exports = __webpack_public_path__ + "img/EX1_memory_old.85334357.jpg";